import Domain from 'umg-ember-backend/components/record-explorer/for/domain';

<template><Domain @records={{@model}} @recordType='domain' /></template>
